import restaurant from '@/assets/img/users-cases/restaurant.webp';
import restaurantHow from '@/assets/img/users-cases/restaurant-how.webp';
import restaurantResult from '@/assets/img/users-cases/restaurant-result.webp';

export default {
  slug: 'restaurant',
  order: 10,
  title: 'Restaurant 3D',
  subtitle: 'Restaurant renderings with lighting-focused 3D scenes',
  tags: ['restaurantfloorplans', 'cafeinteriordesign'],

  images: {
    hero: restaurant,
    aboutTop: restaurantHow,
    aboutBottom: restaurantResult,
  },

  howText:
    'We designed 2D and 3D restaurant floor plans, layouts for restaurants, and interior design for restaurant. Plans consider guest flow, kitchen workflow, and seating arrangements.',

  resultText:
    'Developers and agencies get ready plans for marketing and client presentations, speeding up restaurant openings and investor demonstrations.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: [],
};
